var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.iframe_data.loaded),expression:"iframe_data.loaded"}],attrs:{"width":_vm.iframe_data.width,"height":_vm.iframe_data.height,"src":_vm.iframe_data.src},on:{"load":_vm.load}})}
var staticRenderFns = []

export { render, staticRenderFns }